// @flow
import { useMetaDataContext } from '@streaming-projects/orgs/contexts/SPMetaDataContextProvider';
import React, { createContext, useContext } from 'react';

const SPStreamGovernanceResourceContext = createContext({});

export const SPStreamGovernanceResourceContextProvider = ({ children }) => {
  const dataUniverse = useMetaDataContext().resource_region_details.region_details.map(
    ({ provider_name: provider, ...data }) => ({ provider, ...data })
  );

  return (
    <SPStreamGovernanceResourceContext.Provider value={dataUniverse}>
      {children}
    </SPStreamGovernanceResourceContext.Provider>
  );
};

export const useSPStreamGovernanceResourceContext = () =>
  useContext(SPStreamGovernanceResourceContext);
